<form [formGroup]="form" (ngSubmit)="onSubmitForm()">
  <div class="form-group pt-2 selector-class">
    <label for="templates">
      {{ 'Settings::NamedEntityRecognitionEnabledDefinitions' | abpLocalization }}
    </label>
    <ng-select
      formControlName="templates"
      id="templates"
      [items]="templateList"
      bindLabel="labelClass"
      bindValue="id"
      [multiple]="true"
      [closeOnSelect]="false">
      <ng-template ng-option-tmp let-item="item" let-item$="item$" let-index="index">
        <div
          style="display: flex; align-items: center"
          [ngbTooltip]="'Settings::EntityUseInRedaction' | abpLocalization"
          [disableTooltip]="!item$.disabled"
          container="body">
          <input
            id="item-{{ index }}"
            type="checkbox"
            [disabled]="item$.disabled"
            [ngModel]="item$.selected"
            [ngModelOptions]="{ standalone: true }" />
          <span class="ps-1">
            {{ 'Conversation::NamedEntity:' + item.labelClass | abpLocalization }}
          </span>
        </div>
      </ng-template>
      <ng-template ng-label-tmp let-item="item">
        <span class="ng-value-icon left" aria-hidden="true" (click)="removeFromSelected(item.id)">
          ×
        </span>
        <span class="ng-value-label">
          {{ 'Conversation::NamedEntity:' + item.labelClass | abpLocalization }}
        </span>
      </ng-template>
    </ng-select>
  </div>
  <button type="button" type="submit" class="btn btn-primary mt-3">
    <i class="me-1 fas fa-save"></i>
    {{ 'AbpUi::Save' | abpLocalization }}
  </button>
</form>
